import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken, logUserOut } from '../utils/login';
// Types:
import { loginCustomer } from '../types/customer';

export const validateToken = async (): Promise<loginCustomer> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const tokenRequest: AxiosResponse<loginCustomer> = await API({
    method: 'post',
    url: `/v1/validateToken/`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content: `${content}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return tokenRequest.data;
};
